<template>
  <div>
    <DynamicRender
      :template="scopedCustomJs"
      :data="widgetsData"
      :computed="widgetsComputed"
      />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import DynamicRender from '@/components/DynamicRender'

export default {
  props: [
    'widgetsData',
    'widgetsComputed'
  ],
  components: {
    DynamicRender
  },
  computed: {
    ...mapState([
      'scopedCustomJs'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CustomCodeRender/scopedCodeRenderer.vue